// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 5608) return "static/chunks/5608-50f213baa4114ccd.js";
	if (chunkId === 9334) return "static/chunks/9334-3f20346fced2ee02.js";
	if (chunkId === 8765) return "static/chunks/8765-73b335754a094ef9.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"2834":"d491f28d3666045b","5385":"88ccfa126a513398","5958":"78cee7a27b340f3b"}[chunkId] + ".js";
};